import { render, staticRenderFns } from "./ProductTemplateForm.vue?vue&type=template&id=6e61fa2b"
import script from "./ProductTemplateForm.vue?vue&type=script&lang=js"
export * from "./ProductTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./ProductTemplateForm.vue?vue&type=style&index=0&id=6e61fa2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports